export const contactLeadsData = [
    {
        id: 1,
        user_img: "/images/avatar/2.png",
        user_name: "Archie Cantones",
        user_email: "arcie.tones@gmail.com",
        user_company: "WRAPCODERS",
        user_status: "Completed",
        progress: 78,
        amount: 250.00,
        badgeColor: "success",
        progressColor:"success"
    },

    {
        id: 2,
        user_img: "/images/avatar/3.png",
        user_name: "Holmes Cherryman",
        user_email: "golms.chan@gmail.com",
        user_company: "WRAPCODERS",
        user_status: "In Progress",
        progress: 70,
        amount: 500.00,
        badgeColor: "primary",
        progressColor:"primary"
    },
    {
        id: 3,
        user_img: "/images/avatar/4.png",
        user_name: "Malanie Hanvey",
        user_email: "lanie.nveyn@gmail.com",
        user_company: "WRAPCODERS",
        user_status: "Completed",
        progress: 78,
        amount: 300.00,
        badgeColor: "success",
        progressColor:"success"
    },
    {
        id: 4,
        user_img: "/images/avatar/5.png",
        user_name: "Kenneth Hune",
        user_email: "nneth.une@gmail.com",
        user_company: "WRAPCODERS",
        user_status: "Not Interested",
        progress: 70,
        amount: 200.00,
        badgeColor: "warning",
        progressColor:"warning"
    },
    {
        id: 5,
        user_img: "/images/avatar/6.png",
        user_name: "Valentine Maton",
        user_email: "alenine.aton@gmail.com",
        user_company: "WRAPCODERS",
        user_status: "Completed",
        progress: 78,
        amount: 450.00,
        badgeColor: "success",
        progressColor:"success"
    },
]